/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-11-06T14:58:57.789Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/autotraderTraceParent
export const AutotraderTraceParentZod = z.string();
export type AutotraderTraceParentType = z.TypeOf<typeof AutotraderTraceParentZod>;


// #/components/schemas/autotraderTraceState
export const AutotraderTraceStateZod = z.string();
export type AutotraderTraceStateType = z.TypeOf<typeof AutotraderTraceStateZod>;


// #/components/schemas/autotraderDateTimeValue
export const AutotraderDateTimeValueZod = z.union([z.object({
    kind: z.literal('shift'),
    shift: z.number(),
}), z.object({
    kind: z.literal('dateAt'),
    hour: z.number().optional(),
    minute: z.number().optional(),
    second: z.number().optional(),
}), z.object({
    kind: z.literal('now'),
    empty: z.string().optional(),
})]);
export type AutotraderDateTimeValueType = z.TypeOf<typeof AutotraderDateTimeValueZod>;


// #/components/schemas/autotraderWhereFilter
export const AutotraderWhereFilterZod = z.object({
    field: z.string(),
    operator: z.literal('eq'),
    value: z.union([z.object({
        kind: z.literal('text'),
        text: z.string(),
    }), z.object({
        kind: z.literal('yesno'),
        yesno: z.boolean(),
    }), z.object({
        kind: z.literal('datetime'),
        datetime: AutotraderDateTimeValueZod,
    })]),
});
export type AutotraderWhereFilterType = z.TypeOf<typeof AutotraderWhereFilterZod>;


// #/components/schemas/autotraderInFilter
export const AutotraderInFilterZod = z.object({
    field: z.string(),
    values: z.array(z.string()),
});
export type AutotraderInFilterType = z.TypeOf<typeof AutotraderInFilterZod>;


// #/components/schemas/autotraderBetweenFilter
export const AutotraderBetweenFilterZod = z.object({
    field: z.string(),
    from: z.union([z.object({
        kind: z.literal('text'),
        text: z.string(),
    }), z.object({
        kind: z.literal('yesno'),
        yesno: z.boolean(),
    }), z.object({
        kind: z.literal('datetime'),
        datetime: AutotraderDateTimeValueZod,
    })]),
    to: z.union([z.object({
        kind: z.literal('text'),
        text: z.string(),
    }), z.object({
        kind: z.literal('yesno'),
        yesno: z.boolean(),
    }), z.object({
        kind: z.literal('datetime'),
        datetime: AutotraderDateTimeValueZod,
    })]),
});
export type AutotraderBetweenFilterType = z.TypeOf<typeof AutotraderBetweenFilterZod>;


// #/components/schemas/autotraderAutomationFilterParametrized
export const AutotraderAutomationFilterParametrizedZod = z.object({
    kind: z.literal('parametrized'),
    name: z.string(),
    filter: z.union([z.object({
        kind: z.literal('where'),
        where: AutotraderWhereFilterZod,
    }), z.object({
        kind: z.literal('in'),
        in: AutotraderInFilterZod,
    }), z.object({
        kind: z.literal('between'),
        between: AutotraderBetweenFilterZod,
    })]),
});
export type AutotraderAutomationFilterParametrizedType = z.TypeOf<typeof AutotraderAutomationFilterParametrizedZod>;


// #/components/schemas/autotraderAutomationFilter
export const AutotraderAutomationFilterZod = z.union([z.object({
    kind: z.literal('where'),
    where: AutotraderWhereFilterZod,
}), z.object({
    kind: z.literal('in'),
    in: AutotraderInFilterZod,
}), z.object({
    kind: z.literal('between'),
    between: AutotraderBetweenFilterZod,
}), AutotraderAutomationFilterParametrizedZod, z.object({
    kind: z.literal('nested'),
    field: z.string(),
    filter: z.union([z.object({
        kind: z.literal('where'),
        where: AutotraderWhereFilterZod,
    }), z.object({
        kind: z.literal('in'),
        in: AutotraderInFilterZod,
    }), z.object({
        kind: z.literal('between'),
        between: AutotraderBetweenFilterZod,
    })]),
})]);
export type AutotraderAutomationFilterType = z.TypeOf<typeof AutotraderAutomationFilterZod>;


// #/components/schemas/autotraderEventSelectedBetLimitGroups
export const AutotraderEventSelectedBetLimitGroupsZod = z.object({
    prematch: z.string().optional(),
    show: z.string().optional(),
    inPlay: z.string().optional(),
});
export type AutotraderEventSelectedBetLimitGroupsType = z.TypeOf<typeof AutotraderEventSelectedBetLimitGroupsZod>;


// #/components/schemas/autotraderEventTimeSettings
export const AutotraderEventTimeSettingsZod = z.object({
    offAtStartTime: z.boolean().optional(),
});
export type AutotraderEventTimeSettingsType = z.TypeOf<typeof AutotraderEventTimeSettingsZod>;


// #/components/schemas/autotraderEventSettings
export const AutotraderEventSettingsZod = z.object({
    autoTakeDown: z.boolean().optional(),
    feedSettings: z.object({
        updates: z.boolean().optional(),
    }).optional(),
});
export type AutotraderEventSettingsType = z.TypeOf<typeof AutotraderEventSettingsZod>;


// #/components/schemas/autotraderAutomationEventsCommand
export const AutotraderAutomationEventsCommandZod = z.object({
    selectedBetLimitGroups: AutotraderEventSelectedBetLimitGroupsZod.optional(),
    timeSettings: AutotraderEventTimeSettingsZod.optional(),
    settings: AutotraderEventSettingsZod.optional(),
    display: z.boolean().optional(),
    publishSnapshot: z.boolean().optional(),
    status: z.union([z.literal('Suspended'), z.literal('Open')]).optional(),
});
export type AutotraderAutomationEventsCommandType = z.TypeOf<typeof AutotraderAutomationEventsCommandZod>;


// #/components/schemas/autotraderMarketSettings
export const AutotraderMarketSettingsZod = z.object({
    bestOddsGuaranteed: z.boolean().optional(),
    startingPriceOnly: z.boolean().optional(),
});
export type AutotraderMarketSettingsType = z.TypeOf<typeof AutotraderMarketSettingsZod>;


// #/components/schemas/autotraderAutomationMarketsCommand
export const AutotraderAutomationMarketsCommandZod = z.union([z.object({
    kind: z.literal('update'),
    update: z.object({
        settings: AutotraderMarketSettingsZod.optional(),
    }),
}), z.object({
    kind: z.literal('delete'),
    delete: z.object({
        empty: z.unknown(),
    }),
})]);
export type AutotraderAutomationMarketsCommandType = z.TypeOf<typeof AutotraderAutomationMarketsCommandZod>;


// #/components/schemas/autotraderAutomation
export const AutotraderAutomationZod = z.object({
    id: z.string(),
    name: z.string(),
    schedule: z.object({
        kind: z.literal('cron'),
        cron: z.string(),
    }).optional(),
    actions: z.array(z.union([z.object({
        kind: z.literal('events'),
        events: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationEventsCommandZod,
        }),
    }), z.object({
        kind: z.literal('markets'),
        markets: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationMarketsCommandZod,
        }),
    }), z.object({
        kind: z.literal('wait'),
        wait: z.object({
            seconds: z.number(),
        }),
    })])),
    active: z.boolean(),
    limit: z.number(),
});
export type AutotraderAutomationType = z.TypeOf<typeof AutotraderAutomationZod>;


// #/components/schemas/autotraderAutomationData
export const AutotraderAutomationDataZod = z.object({
    name: z.string(),
    schedule: z.object({
        kind: z.literal('cron'),
        cron: z.string(),
    }).optional(),
    actions: z.array(z.union([z.object({
        kind: z.literal('events'),
        events: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationEventsCommandZod,
        }),
    }), z.object({
        kind: z.literal('markets'),
        markets: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationMarketsCommandZod,
        }),
    }), z.object({
        kind: z.literal('wait'),
        wait: z.object({
            seconds: z.number(),
        }),
    })])),
    active: z.boolean(),
    limit: z.number(),
});
export type AutotraderAutomationDataType = z.TypeOf<typeof AutotraderAutomationDataZod>;


// #/components/schemas/autotraderAutomationPartial
export const AutotraderAutomationPartialZod = z.object({
    name: z.string().optional(),
    schedule: z.union([z.null(), z.object({
        kind: z.literal('cron'),
        cron: z.string(),
    })]).optional(),
    actions: z.array(z.union([z.object({
        kind: z.literal('events'),
        events: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationEventsCommandZod,
        }),
    }), z.object({
        kind: z.literal('markets'),
        markets: z.object({
            filters: z.array(AutotraderAutomationFilterZod),
            command: AutotraderAutomationMarketsCommandZod,
        }),
    }), z.object({
        kind: z.literal('wait'),
        wait: z.object({
            seconds: z.number(),
        }),
    })])).optional(),
    active: z.boolean().optional(),
    limit: z.number().optional(),
});
export type AutotraderAutomationPartialType = z.TypeOf<typeof AutotraderAutomationPartialZod>;


// #/components/schemas/autotraderRunData
export const AutotraderRunDataZod = z.object({
    parameters: z.record(z.string(), z.union([z.object({
        kind: z.literal('where'),
        where: AutotraderWhereFilterZod,
    }), z.object({
        kind: z.literal('in'),
        in: AutotraderInFilterZod,
    }), z.object({
        kind: z.literal('between'),
        between: AutotraderBetweenFilterZod,
    }), AutotraderAutomationFilterParametrizedZod, z.object({
        kind: z.literal('nested'),
        field: z.string(),
        filter: z.union([z.object({
            kind: z.literal('where'),
            where: AutotraderWhereFilterZod,
        }), z.object({
            kind: z.literal('in'),
            in: AutotraderInFilterZod,
        }), z.object({
            kind: z.literal('between'),
            between: AutotraderBetweenFilterZod,
        })]),
    })])).optional(),
});
export type AutotraderRunDataType = z.TypeOf<typeof AutotraderRunDataZod>;


// #/components/schemas/autotraderRunState
export const AutotraderRunStateZod = z.union([z.literal('pending'), z.literal('running'), z.literal('finished'), z.literal('error')]);
export type AutotraderRunStateType = z.TypeOf<typeof AutotraderRunStateZod>;


// #/components/schemas/autotraderRun
export const AutotraderRunZod = z.object({
    id: z.string(),
    userId: z.string().optional(),
    createdAt: z.string(),
    executedAt: z.string().optional(),
    state: AutotraderRunStateZod,
    log: z.array(z.union([z.object({
        kind: z.literal('traceId'),
        traceId: z.string(),
    }), z.object({
        kind: z.literal('started'),
        started: z.string(),
    }), z.object({
        kind: z.literal('finished'),
        finished: z.string(),
    }), z.object({
        kind: z.literal('markets'),
        markets: z.number(),
    }), z.object({
        kind: z.literal('events'),
        events: z.number(),
    }), z.object({
        kind: z.literal('eventsOverview'),
        eventsOverview: z.array(z.object({
            id: z.string(),
            numericId: z.number(),
            name: z.string(),
        })),
    }), z.object({
        kind: z.literal('error'),
        error: z.string(),
    })])).optional(),
    parameters: z.record(z.string(), z.union([z.object({
        kind: z.literal('where'),
        where: AutotraderWhereFilterZod,
    }), z.object({
        kind: z.literal('in'),
        in: AutotraderInFilterZod,
    }), z.object({
        kind: z.literal('between'),
        between: AutotraderBetweenFilterZod,
    }), AutotraderAutomationFilterParametrizedZod, z.object({
        kind: z.literal('nested'),
        field: z.string(),
        filter: z.union([z.object({
            kind: z.literal('where'),
            where: AutotraderWhereFilterZod,
        }), z.object({
            kind: z.literal('in'),
            in: AutotraderInFilterZod,
        }), z.object({
            kind: z.literal('between'),
            between: AutotraderBetweenFilterZod,
        })]),
    })])).optional(),
});
export type AutotraderRunType = z.TypeOf<typeof AutotraderRunZod>;

